export function createDirtyNode(doc: XMLDocument, name: string): HTMLElement {
  const node = doc.createElement(name);
  node.setAttribute('DIRTY', 'TRUE');

  return node;
}

export function createNodeWithText(
  doc: XMLDocument,
  name: string,
  text: string | undefined,
): HTMLElement {
  const node = createDirtyNode(doc, name);
  node.textContent = text ?? '';

  return node;
}
